import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { rem } from 'polished';
import { colors, mixins, spaces } from '../../core/styles/theme/default';
import Hidden from '../../helpers/Hidden';
import MagneticField from '../../components/MagneticField';

const StyledBackgroundPanel = styled.div(
  () => css`
    position: absolute;
    top: 0;
    right: 0;
    z-index: 0;
    width: 65vw;
    overflow: hidden;

    ${mixins.responsiveStyles({
      height: {
        zero: 800,
        small: 380,
        medium: 970,
        large: 490,
        wide: 530,
        ultra: 570,
      },
      top: {
        zero: 145,
        medium: 0,
      },
    })}

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: calc(100% - ${rem(spaces.iota)});
      background-color: ${colors.blue200};
    }
  `,
);

const StyledDecoration = styled.div`
  position: absolute;
  left: 20%;
  top: 20%;
  z-index: 1;
  opacity: 0.25;

  ${mixins.MQMax('medium')} {
    left: 45%;
  }
`;

const BackgroundPanel = () => {
  return (
    <StyledBackgroundPanel>
      <StyledDecoration>
        <Hidden below="large">
          <MagneticField isVisible={true} />
        </Hidden>
      </StyledDecoration>
    </StyledBackgroundPanel>
  );
};

export type BackgroundPanelProps = {};

export default BackgroundPanel;
